import getIn from 'transmute/getIn';
import { CommonMessageAttachments } from '../records/CommonMessage';
import { FILE_IDS, FILE_SENSITIVITY_EXEMPTION, FILE_USAGE_TYPES } from '../constants/fileAttachmentKeyPaths';
export const getFileIds = getIn(FILE_IDS);
export const getFileUsageTypes = getIn(FILE_USAGE_TYPES);
export const getFileSensitivityExemption = getIn(FILE_SENSITIVITY_EXEMPTION);